import React, { useState } from 'react';
import MachineGroups from './MachineGroups';
import CreateAccountForm from './CreateAccountForm';
import DashboardSection from '../components/DashboardSection';
import useDeepLinkedSection from '../navigation/useDeepLinkedSection';
import './Accounts.css';

// DJB-171: the Accounts › Manager sections sit on the Dashboard's borderless
// collapsible shell inside the 1800px page container (the same treatment the
// Library and Curator pages got in DJB-159/160). Both sections start expanded
// (they were always visible before) and collapse independently.
const Accounts = () => {
  const [openSections, setOpenSections] = useState(
    () => new Set(['create-machine', 'groups'])
  );

  const openSection = (key) =>
    setOpenSections((prev) => (prev.has(key) ? prev : new Set(prev).add(key)));

  const toggleSection = (key) =>
    setOpenSections((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });

  // DJB-112: a section picked from the left nav arrives as ?section=<anchor>
  // and must open even if the user collapsed it
  useDeepLinkedSection(
    {
      'section-create-machine': 'create-machine',
      'section-groups': 'groups',
    },
    openSection
  );

  return (
    <div className="accounts-page">
      {/* DJB-110: section renamed from "Create Accounts" */}
      <DashboardSection
        id="section-create-machine"
        title="Create Machine"
        isOpen={openSections.has('create-machine')}
        onToggle={() => toggleSection('create-machine')}
        bodyId="dashboard-section-body-create-machine"
      >
        <CreateAccountForm />
      </DashboardSection>

      <DashboardSection
        id="section-groups"
        title="Groups"
        isOpen={openSections.has('groups')}
        onToggle={() => toggleSection('groups')}
        bodyId="dashboard-section-body-groups"
      >
        <MachineGroups />
      </DashboardSection>
    </div>
  );
};

export default Accounts;
